import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDefaultGridProps } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/gridHelpers';
import AgGridReact from 'ui/AgGridReact/AgGridReact';

import NoDataResume from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Resume/NoDataResume';
import { ColDef, ColGroupDef, GetRowIdParams } from 'ag-grid-community';
import AgentHypothesisResumeCellRenderer from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Resume/HsHcHypothesesResume/AgentPayComponentHypothesisResume/AgentHypothesisResumeCellRenderer';
import EditEnvelopePayComponentHypothesisCellRenderer from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/PayComponentHypothesis/EditEnvelopePayComponentHypothesisCellRenderer';
import { DetailedAgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import { DetailedEnvelopePayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/PayComponentHypothesis/helpers/types';
import { AgGridReactProps } from 'ag-grid-react';

type Props = {
    detailedPayComponentHypothesis:
        | DetailedEnvelopePayComponentHypothesis[]
        | DetailedAgentPayComponentHypothesis[]
        | undefined;
    columnDefs: Array<ColDef | ColGroupDef>;
    gridProps?: AgGridReactProps;
};

const PayComponentHypothesisResumeGrid = ({
    detailedPayComponentHypothesis,
    columnDefs,
    gridProps: parentGridProps,
}: Props) => {
    const { t } = useTranslation();
    const getRowId = useCallback(
        (params: GetRowIdParams) => Object.values(params.data).join('-'),
        [],
    );
    const defaultProps = getDefaultGridProps();
    const gridProps = {
        ...defaultProps,
        ...parentGridProps,
        getRowId,
        sideBar: undefined,
        components: {
            ...defaultProps.components,
            editEnvelopePayComponentHypothesisCellRenderer:
                EditEnvelopePayComponentHypothesisCellRenderer,
            agentHypothesisCellRenderer: AgentHypothesisResumeCellRenderer,
        },
        defaultColDef: {
            flex: 1,
        },
    };

    const envelopePayComponentHypotheses = detailedPayComponentHypothesis ?? [];

    return (
        <>
            {envelopePayComponentHypotheses.length === 0 ? (
                <NoDataResume
                    text={t('humanResources.simulation.noHypotheses')}
                />
            ) : (
                <AgGridReact
                    {...gridProps}
                    rowData={envelopePayComponentHypotheses}
                    columnDefs={columnDefs}
                />
            )}
        </>
    );
};

export default PayComponentHypothesisResumeGrid;
